import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Linkify from 'linkifyjs/react';
import _get from 'lodash/get';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Comment.module.css';
import CommentActions from 'components/Comments/CommentActions/CommentActions';
import VideoModal from 'components/Modals/VideoModal/VideoModal';
import PostDetailCommentForm from 'containers/Comments/PostDetailCommentForm/PostDetailCommentForm';
import HelpTile from 'containers/UI/HelpTile/HelpTile';
import { formatDateForPostDetails, getAuthorName, getRgbFromColorName } from 'shared/utility';
import * as actions from 'store/actions';

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommentActions: false,
      showEditCommentForm: false,
      showReplyToCommentForm: false,
      activeCommentId: this.props.activeCommentId,
      showVideo: false,
      videoURL: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeCommentId !== prevProps.activeCommentId) {
      this.setState({ activeCommentId: this.props.activeCommentId });
    }
    if (this.props.contributeFormOpen === true && prevProps.contributeFormOpen === false) {
      this.setState({ showEditCommentForm: false, showReplyToCommentForm: false });
    }
  }

  toggleVideo = (url) => {
    this.setState({ showVideo: !this.state.showVideo, videoURL: url });
  };

  editComment = (commentId) => {
    this.setState({ showEditCommentForm: true, showCommentActions: false });
    this.props.closeContributeForm();
    this.props.updateActiveComment(commentId);
  };

  replyToComment = (commentId) => {
    this.props.onClearCommentImages('replyToComment');
    this.props.updateActiveComment(commentId);
    this.props.closeContributeForm();
    this.setState({ showReplyToCommentForm: true, showCommentActions: false });
  };

  cancelComment = (showCommentType, CommentType) => {
    this.props.onClearCommentImages(CommentType);
    this.props.updateActiveComment(null);
    this.setState({ [showCommentType]: false, showCommentActions: false });
  };

  toggleComponent = (componentName) => {
    this.setState({ [componentName]: !this.state[componentName] });
  };

  showCommentActions = (event) => {
    event.stopPropagation();
    this.setState({ showCommentActions: true });
  };

  hideCommentActions = (event) => {
    event.stopPropagation();
    this.setState({ showCommentActions: false });
  };

  render = () => {
    const commentClasses = [classes.Comment];
    const author = this.props.users.find((user) => user.UserId === this.props.comment.ByUserId);
    const postFileIds = this.props.post && this.props.post.Post && this.props.post.Files ? this.props.post.Files.Files.map((file) => file.Id) : [];
    const imageAddable =
      this.props.post &&
      this.props.comment.File &&
      !postFileIds.includes(this.props.comment.File.Id) &&
      this.props.post.Post &&
      this.props.postingAs &&
      this.props.postingAs.UserId === this.props.post.Post.UserId;
    if (imageAddable) commentClasses.push(classes.ImageAddable);

    let comment = (
      <div key={this.props.comment.Id} className={commentClasses.join(' ')}>
        {this.props.showCommentHeader === true ? (
          <div className={classes.CommentHeader}>
            {author ? (
              <span className={classes.CommentAuthor} style={{ color: getRgbFromColorName(author.Color) }}>
                {getAuthorName(author.NickName, author.FirstName, author.LastName)}
              </span>
            ) : null}
            <span className={classes.CommentTimeSince}>{formatDateForPostDetails(this.props.comment.Date)}</span>
          </div>
        ) : null}
        {this.props.comment.File ? (
          <div className={classes.CommentImage}>
            {this.props.comment.File.MediaType === 'Video' ? (
              <HelpTile
                toggle={() => this.toggleVideo(this.props.comment.File.FileURL)}
                videoUrl={this.props.comment.File.MediumImageURL}
                imageUrl={this.props.comment.File.MediumImageURL}
                videoLengthInSeconds={this.props.comment.File.MediaType === 'Video' ? this.props.comment.File.DurationInMs / 1000 : null}
              />
            ) : (
              <img
                src={this.props.comment.File.FileURL}
                alt={`comment-image-${this.props.comment.File.Id}`}
                onClick={() => this.props.renderCommentImage(this.props.comment.File)}
              />
            )}
            <FontAwesomeIcon icon="plus" className={classes.AddImageIcon} onClick={() => this.props.addImageToPost(this.props.comment.File.Id)} />
          </div>
        ) : null}
        {this.props.comment.Comment ? (
          <div className={classes.CommentBody}>
            {' '}
            <Linkify tagName="p">{this.props.comment.Comment}</Linkify>
          </div>
        ) : null}
      </div>
    );

    let replyForm = null;

    if (this.state.showReplyToCommentForm === true) {
      replyForm = (
        <PostDetailCommentForm
          commentType="replyToComment"
          comment={this.props.comment}
          parentCommentId={this.props.comment.Id}
          logId={this.props.logId}
          postId={this.props.postId}
          activeCommentId={this.state.activeCommentId}
          commentError={this.props.commentError}
          shown={this.state.showReplyToCommentForm === true && this.props.activeCommentId === this.props.comment.Id}
          cancelComment={() => this.cancelComment('showReplyToCommentForm', 'replyToComment')}
        />
      );
    }
    if (this.state.showEditCommentForm === true) {
      comment = (
        <PostDetailCommentForm
          isReply={this.props.commentType === 'reply'}
          commentType="editComment"
          comment={this.props.comment}
          editImage={!!this.props.comment.File}
          editImageThumbURL={_get(this.props, 'comment.File.ImageURL', _get(this.props, 'comment.File.ThumbURL', null))}
          editImageId={this.props.comment.File ? this.props.comment.File.Id : null}
          commentId={this.props.comment.Id}
          postId={this.props.postId}
          logId={this.props.logId}
          commentError={this.props.commentError}
          shown={this.state.showEditCommentForm === true && this.props.activeCommentId === this.props.comment.Id}
          cancelComment={() => this.cancelComment('showEditCommentForm', 'editComment')}
        />
      );
    }

    let replies = null;
    if (this.props.comment.SubComments && this.props.comment.SubComments.length > 0) {
      let commentGroupId = null;
      const repliesArray = [...this.props.comment.SubComments].sort((a, b) => {
        if (moment(a.Date).isBefore(moment(b.Date))) {
          return -1;
        }
        if (a.Date === b.Date) {
          if (a.Comment.length > 0) {
            return -1;
          }
          if (a.File) {
            return 1;
          }
          if (a.Tags) {
            return 0;
          }
        }
        return -1;
      });

      const replyList = repliesArray.map((reply) => {
        const showCommentHeader = !(reply.ComGroupId === commentGroupId && reply.ComGroupId !== undefined);
        commentGroupId = reply.ComGroupId;
        return (
          <Comment
            onClearCommentImages={this.props.onClearCommentImages}
            updateActiveComment={this.props.updateActiveComment}
            addTagToPost={this.props.addTagToPost}
            comment={reply}
            commentType="reply"
            postTags={this.props.postTags}
            isPostDetails={this.props.classes === 'PostDetails'}
            contributeFormOpen={this.props.contributeFormOpen}
            closeContributeForm={this.props.closeContributeForm}
            isAuthor={!!(this.props.postingAs && reply.ByUserId === this.props.postingAs.UserId)}
            postId={this.props.postId}
            postingAs={this.props.postingAs}
            post={this.props.post}
            users={this.props.users}
            logId={this.props.logId}
            parentComment={this.props.comment}
            activeCommentId={this.state.activeCommentId}
            key={reply.Id}
            onUpdateComment={this.props.onUpdateComment}
            showCommentHeader={showCommentHeader}
          />
        );
      });
      replies = <div className={classes.CommentReplies}> {replyList}</div>;
    }
    const repliesEnabled = !(this.props.commentType === 'reply' || this.props.commentType === 'adminNote');
    const isAuthor = !!((this.props.postingAs && this.props.comment.ByUserId === this.props.postingAs.UserId) || this.props.isAuthor === true);
    const editingEnabled = this.props.comment.File ? false : true && isAuthor === true;
    const isPostAuthor = this.props.post && this.props.post.Post.UserId === this.props.postingAs.UserId;
    let showActions = this.state.showCommentActions && (this.state.activeCommentId !== this.props.comment.Id || !this.props.comment.ComGroupId);
    const tagsList = [];
    const tagTypes = ['WhatTags', 'WhoTags', 'LocationTags'];
    if (this.props.comment.Tags)
      tagTypes.forEach((tagType, i) => this.props.comment.Tags[tagType].forEach((tag) => tagsList.push({ tagClassName: tagTypes[i], tag })));
    const tags = tagsList.map((tagObject, i) => {
      const isPostTag =
        this.props.postTags[tagObject.tagClassName].includes(tagObject.tag) ||
        (this.props.post.Post && this.props.postingAs && this.props.postingAs.UserId !== this.props.post.Post.UserId);
      const tagClasses = [classes.Tag, classes[tagObject.tagClassName]];
      if (isPostTag) tagClasses.push(classes.PostTag);
      return (
        <span
          key={i}
          className={tagClasses.join(' ')}
          onClick={() => {
            if (!isPostTag) {
              this.props.addTagToPost(tagObject.tag, tagObject.tagClassName);
            }
          }}
        >
          {tagObject.tag}
          <FontAwesomeIcon icon="plus" className={classes.PlusIcon} />
        </span>
      );
    });
    if (isAuthor === false && repliesEnabled === false && editingEnabled === false) showActions = false;
    const commentContainerClasses = [classes.CommentContainer];
    commentContainerClasses.push(classes[this.props.classes]);
    if (this.props.showCommentHeader === false) commentContainerClasses.push(classes.HeaderLessComment);
    if (this.props.comment.File) {
      commentContainerClasses.push(classes.ImageComment);
    }
    return (
      <div key={this.props.comment.Id} className={commentContainerClasses.join(' ')}>
        <div
          onMouseEnter={(event) => this.showCommentActions(event, 'mouseenter', this.props.comment.Comment)}
          onMouseLeave={(event) => this.hideCommentActions(event, 'mouseleave', this.props.comment.Comment)}
        >
          <CommentActions
            commentType={this.props.commentType}
            toggleDeleteCommentDialogue={() => this.props.toggleDeleteCommentDialogue(this.props.comment.Id)}
            isPostDetails={!!(this.props.classes === 'PostDetails' || this.props.isPostDetails)}
            replyToComment={() => this.replyToComment(this.props.comment.Id)}
            editComment={() => this.editComment(this.props.comment.Id)}
            enableEdit={editingEnabled}
            enableReply={repliesEnabled}
            isAuthor={isAuthor}
            isPostAuthor={isPostAuthor}
            show={showActions}
          />
          {this.state.showVideo && (
            <VideoModal show={this.state.showVideo} toggleVideo={this.toggleVideo} videoUrl={this.state.videoURL} orientation="horizontal" />
          )}
          {comment}
          {tagsList.length > 0 && !this.state.showEditCommentForm ? <div className={classes.Tags}>{tags}</div> : null}
        </div>
        {replies}
        {replyForm}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    postingAs: state.user.postingAs,
    isManagedUser: state.user.postingAs.UserId !== state.user.signedInAs.UserId,
    commentError: state.post.commentError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateComment: (CommentId, C, Delete, isManagedUser, UserId, LogId) =>
      dispatch(actions.entryCommentUpdate(CommentId, C, Delete, isManagedUser, UserId, LogId)),
    onClearCommentImages: (CommentType) => dispatch(actions.clearCommentImages(CommentType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comment);
